import { render, staticRenderFns } from "./PageCongratulations.vue?vue&type=template&id=08dc2bfc&scoped=true"
import script from "./PageCongratulations.vue?vue&type=script&lang=js"
export * from "./PageCongratulations.vue?vue&type=script&lang=js"
import style0 from "./PageCongratulations.vue?vue&type=style&index=0&id=08dc2bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc2bfc",
  null
  
)

export default component.exports